(() => {
  if (window.rsMaterialGuideInstalled) return;
  window.rsMaterialGuideInstalled = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const records = new Map();
  const reveal = scope => {
    if (motion.matches || !('IntersectionObserver' in window)) return;
    const nodes = [...scope.querySelectorAll('[data-rs-material-reveal]')].filter(node => !node.dataset.rsRevealReady);
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    nodes.forEach(node => { node.dataset.rsRevealReady = 'true'; node.classList.add('rs-material-revealing'); observer.observe(node); });
    const show = () => { nodes.forEach(node => node.classList.add('is-visible')); observer.disconnect(); };
    motion.addEventListener('change', show, { once: true });
    const timeout = setTimeout(show, 12000);
    return () => { clearTimeout(timeout); observer.disconnect(); motion.removeEventListener('change', show); };
  };
  const init = scope => {
    const guides = scope.matches?.('[data-rs-material-guide]') ? [scope] : [...scope.querySelectorAll('[data-rs-material-guide]')];
    guides.forEach(root => {
      if (records.has(root)) return;
      const controller = new AbortController(), signal = controller.signal;
      const photo = root.querySelector('.rs-material-guide__photo');
      const stage = root.querySelector('[data-rs-photo-stage]');
      const zoom = root.querySelector('[data-rs-zoom]');
      const host = root.querySelector('[data-rs-model-host]');
      const start = root.querySelector('[data-rs-model-start]');
      const close = root.querySelector('[data-rs-model-close]');
      const caption = root.querySelector('[data-rs-model-caption]');
      const status = root.querySelector('[data-rs-model-status]');
      let viewerUI, loadTimer, modelController, generation = 0, loading = false;
      root.querySelector('[data-rs-thumbnails]')?.removeAttribute('hidden');
      root.querySelector('[data-rs-tools]')?.removeAttribute('hidden');
      const resetModel = () => {
        generation++; modelController?.abort();
        clearTimeout(loadTimer); loading = false;
        viewerUI?.destroy?.(); viewerUI = undefined;
        if (host) { host.replaceChildren(); host.hidden = true; }
        if (photo) photo.hidden = false;
        if (start) { start.hidden = false; start.disabled = false; }
        if (close) close.hidden = true;
        if (caption) caption.hidden = true;
        if (zoom) zoom.hidden = false;
        if (status) status.textContent = '';
      };
      const failed = () => { resetModel(); if (status) status.textContent = status.dataset.error; };
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.matches('[data-rs-photo]') && photo) {
          resetModel(); photo.srcset = button.dataset.rsSrcset; photo.src = button.dataset.rsPhoto;
          root.querySelectorAll('[data-rs-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          stage?.classList.remove('is-zoomed'); zoom?.setAttribute('aria-pressed','false');
        }
        if (button === zoom) { const active = stage.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed',String(active)); }
        if (button === close) { resetModel(); start?.focus(); }
        if (button === start && !loading) {
          if (!window.Shopify?.loadFeatures || !host) { failed(); return; }
          const request = ++generation;
          modelController?.abort(); modelController = new AbortController();
          const modelSignal = modelController.signal;
          const current = () => !signal.aborted && !modelSignal.aborted && request === generation;
          loading = true; start.disabled = true; status.textContent = status.dataset.loading;
          loadTimer = setTimeout(() => { if (current()) failed(); }, 20000);
          window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad: errors => {
            if (!current()) return;
            if (errors) { failed(); return; }
            host.append(root.querySelector('[data-rs-model-template]').content.cloneNode(true));
            const viewer = host.querySelector('model-viewer');
            if (!viewer) { failed(); return; }
            host.hidden = false;
            close.hidden = false;
            viewer.addEventListener('load', () => {
              if (!current()) return;
              clearTimeout(loadTimer); loading = false;
              if (photo) photo.hidden = true;
              start.hidden = true; close.hidden = false; caption.hidden = false; zoom.hidden = true;
              status.textContent = '';
              try { viewerUI = new window.Shopify.ModelViewerUI(viewer); } catch (_) {}
              viewer.focus();
            }, { once:true, signal:modelSignal });
            viewer.addEventListener('error', () => { if (current()) failed(); }, { once:true, signal:modelSignal });
          }}]);
        }
      }, { signal });
      records.set(root, () => { controller.abort(); resetModel(); });
    });
    const cleanupReveal = reveal(scope);
    if (cleanupReveal) records.set(scope, cleanupReveal);
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {
    for (const [node,cleanup] of records) if (node === event.target || event.target.contains(node)) { cleanup(); records.delete(node); }
  });
  document.addEventListener('shopify:block:select',event => {event.target.classList.add('is-visible');event.target.closest('[data-rs-material-reveal]')?.classList.add('is-visible');});
})();
